import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {
  TextField,
  Button,
  InputLabel,
  FormControl,
  FormHelperText,
  FormGroup,
  Select as MuiSelect,
  Checkbox,
  Dialog
} from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';

import { SelectMultiField } from '../../common';
import { setData } from '../../../redux/dataSlice';
import { baseApiUrl } from '../../../config';

// TODO: specialty and degree should be a tagcloud, if from npi registry and no specialty or degree match then do other and add to other field

const VTMNVerbiageLicensed =
  'Licensed providers from VT or MN are not permitted to register or attend Sobi Speaker Bureau Programs';
const VTMNVerbiage =
  'Providers from VT or MN are not permitted to register or attend Sobi Speaker Bureau Programs';
const StateEmployeeVerbiage =
  'State employees from Colorado, Connecticut, Kentucky, or Louisiana are not permitted to register or attend Sobi Speaker Bureau Programs';
const FormularyCommiteeVerbiage =
  'Those who serve on a formulary committee for the District of Columbia are not permitted to register or attend Sobi Speaker Bureau Programs';

const SobiRegFormComponent = (props) => {
  const { dropDownValues, isLicensed, npiInfo, meetingInfo, setData, regSource } = props;

  const [formValues, setFormValues] = React.useState({
    meeting_id: meetingInfo.id,
    reg_source: regSource,
    email_consent: true,
    communication_optin: true
  });
  const [formErrors, setFormErrors] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(null);
  const [errModalOpen, setErrModalOpen] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState('');

  const [npiDataObj, setNpiDataObj] = React.useState({});
  const [attendanceType, setAttendanceType] = React.useState(null);

  const [isVtMn, setisVtMn] = React.useState(null);
  const [isStateEmploee, setIsStateEmployee] = React.useState(null);
  const [isFormularyCommittee, setIsFormularyCommittee] = React.useState(null);

  // for specialties and degrees if isLicensed remove Other from the list

  const specialties = isLicensed
    ? _.filter(
        dropDownValues.specialties,
        (spclty) => !_.includes(['OTHER', 'UNSPECIFIED'], spclty.name.toUpperCase())
      )
    : dropDownValues.specialties;
  const degrees = isLicensed
    ? _.filter(dropDownValues.degrees, (degree) => degree.name.toUpperCase() !== 'OTHER')
    : dropDownValues.degrees;

  const roles = _.filter(dropDownValues.roles, (rle) => rle.descriptionshort !== 'OTH');

  React.useEffect(() => {
    if (isLicensed && !_.isEmpty(npiInfo)) {
      let npiData = {};
      if (_.keys(npiInfo).includes('basic')) {
        // data coming from the npi registry
        const { basic, addresses, taxonomies } = npiInfo;

        console.log('data coming from nppes', npiInfo);
        npiData = {
          npi: npiInfo.number,
          firstname: basic.first_name,
          lastname: basic.last_name,
          minitial: basic.middle_name ? basic.middle_name[0] : '',
          address1: addresses[0].address_1 || '',
          address2: addresses[0].address_2 || '',
          city: addresses[0].city || '',
          state: addresses[0].state || '',
          zip: addresses[0].postal_code || '',
          ...computeTagCloudValues(
            _.compact(taxonomies.map((taxonomy) => taxonomy.desc)),
            specialties,
            'specialty'
          ),
          ...computeTagCloudValues(_.compact([basic.credential]), degrees, 'degree')
        };
      } else {
        // data coming from the hlx database
        console.log('data coming from the hlx/medpro database', npiInfo);
        npiData = {
          contactId: npiInfo.contactid,
          npi: npiInfo.npinumber,
          firstname: npiInfo.firstname,
          lastname: npiInfo.lastname,
          minitial: npiInfo.middleinitial,
          orgname: npiInfo.orgname,
          address1: npiInfo.orgaddress1,
          address2: npiInfo.orgaddress2,
          phone: npiInfo.phone,
          city: npiInfo.orgcity,
          state: npiInfo.orgstate,
          zip: npiInfo.orgpostalcode,
          email: npiInfo.email,
          ...computeTagCloudValues(
            _.compact(npiInfo.specialty.split(',').map((spclty) => spclty.trim())),
            specialties,
            'specialty'
          ),
          ...computeTagCloudValues(
            _.compact(npiInfo.medicaldegree.split(',').map((dgr) => dgr.trim())),
            degrees,
            'degree'
          )
        };
      }
      setNpiDataObj(npiData);
      setFormValues({ ...formValues, ...npiData });

      if (npiData.state && _.includes(['MN', 'VT'], npiData.state)) {
        setisVtMn(true);
        triggerBlockerModal();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const computeTagCloudValues = (incomingValues, incomingdropDownValues, objectKey) => {
    console.log('incoming', objectKey, incomingValues);
    const tagArray = [];
    let otherElem = '';
    // let otherTagFlag = false;
    if (incomingValues && incomingValues.length > 0) {
      // const otherDropDownElem = _.find(
      //   incomingdropDownValues,
      //   (elem) => elem.name.toUpperCase() === 'OTHER'
      // );

      incomingValues.forEach((elemName) => {
        if (elemName.toUpperCase() !== 'OTHER') {
          const dropdownElem = _.find(
            incomingdropDownValues,
            (elem) => elem.name.toUpperCase() === elemName.toUpperCase()
          );
          const valueName = dropdownElem && dropdownElem.name;
          if (valueName) {
            tagArray.push({ value: valueName, label: valueName });
          }
          // } else {
          //   if (otherDropDownElem) {
          //     if (!otherTagFlag) {
          //       tagArray.push({
          //         value: otherDropDownElem.name,
          //         label: otherDropDownElem.name
          //       });
          //       otherTagFlag = true;
          //     }
          //     otherElem = otherElem.length ? (otherElem += `, ${elemName}`) : elemName;
          //   }
          // }
        }
      });
    }
    return { [objectKey]: tagArray, [`other_${objectKey}`]: otherElem };
  };

  const validateFields = () => {
    let requiredFields = [
      'firstname',
      'lastname',
      // 'specialty',
      'orgname',
      'address1',
      'city',
      'state',
      'zip',
      // 'phone',
      'email',
      'email_consent'
    ];
    if (isLicensed) {
      // const reqFields = ['npi', 'degree', 'licensed_state'];
      const reqFields = ['npi', 'licensed_state', 'degree', 'specialty'];
      (formValues.degree || []).forEach((degree) => {
        if (degree.value.toUpperCase() === 'OTHER') {
          reqFields.push('other_degree');
        }
      });
      requiredFields = requiredFields.concat(reqFields);
    } else {
      //requiredFields.push('role');
      requiredFields.push('role');
      if (formValues.role?.toUpperCase() === 'OTH') {
        requiredFields.push('other_role');
      }
    }

    (formValues.specialty || []).forEach((specialty) => {
      if (specialty.value.toUpperCase() === 'OTHER') {
        requiredFields.push('other_specialty');
      }
    });

    const errors = {};
    requiredFields.forEach((field) => {
      if (!formValues[field] || (_.isArray(formValues[field]) && formValues[field].length === 0)) {
        errors[field] = true;
      }
    });
    if (formValues.npi) {
      var is10digits = /^\d{10}$/.test(formValues.npi);
      if (!is10digits) {
        errors['npi'] = true;
      }
    }

    if (formValues.email) {
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(formValues.email)) {
        errors['email'] = true;
      }
    }

    if (!_.isBoolean(isVtMn)) {
      errors['isVtMn'] = true;
    }

    if (!_.isBoolean(isStateEmploee)) {
      errors['isStateEmploee'] = true;
    }
    if (!_.isBoolean(isFormularyCommittee)) {
      errors['isFormularyCommittee'] = true;
    }

    if (meetingInfo.is_virtual_hybrid && !attendanceType) {
      errors['attendanceType'] = true;
    }

    console.log('errors', errors);
    setFormErrors(errors);
    return _.isEmpty(errors) ? true : false;
  };

  const submitForm = async () => {
    const isValid = validateFields();
    console.log('isValid', isValid, formErrors);

    if (
      isVtMn ||
      _.includes(['MN', 'VT'], formValues.licensed_state) ||
      _.includes(['MN', 'VT'], formValues.state)
    ) {
      triggerBlockerModal(VTMNVerbiage);
      return;
    }

    if (isStateEmploee) {
      triggerBlockerModal(StateEmployeeVerbiage);
      return;
    }
    if (isFormularyCommittee) {
      triggerBlockerModal(FormularyCommiteeVerbiage);
      return;
    }

    formValues.isLicensed = isLicensed;

    if (isValid) {
      console.log('formValues', formValues);
      const formPayload = { ...formValues };

      formPayload.specialty = _.map(formPayload.specialty || [], 'value').join(', ');
      if (formPayload.other_specialty) {
        formPayload.specialty = formPayload.specialty + ', ' + formPayload.other_specialty;
      }
      formPayload.degree = _.map(formPayload.degree || [], 'value').join(', ');
      if (formPayload.other_degree) {
        formPayload.degree = formPayload.degree + ', ' + formPayload.other_degree;
      }

      if (formPayload.role?.toUpperCase() === 'OTH') {
        formPayload.role = formPayload.other_role;
      }

      if (meetingInfo.is_virtual_hybrid) {
        formPayload.is_virtual_attendee = attendanceType === 'virtual' ? 1 : 0;
      }

      const req = await fetch(`${baseApiUrl}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...formPayload, contactId: npiInfo.contactid })
      });
      if (req.status === 201) {
        setSubmitted(true);
      } else if (req.status === 403) {
        setSubmitError('This meeting is at capacity.');
      } else if (req.status === 401) {
        setErrMsg(
          'You are unable to register for this program because you have already attended or registered for the allocated number of meetings with this talk title within the calendar year. <br/><br/>If you have any questions, or believe you have received this message in error, please contact your local Sobi representative.'
        );
        setErrModalOpen(true);
      } else if (req.status === 406) {
        setErrMsg(
          'We&apos;re sorry, but you are unable to attend this program. Please contact your local representative if you have any questions or believe this may be an error.'
        );
        setErrModalOpen(true);
      } else {
        setSubmitError('Something went wrong with your submission.');
      }
    }
  };

  const toggleErrModal = () => {
    // this is just used to close the modal for now
    setErrModalOpen(!errModalOpen);
    setErrMsg('');
  };

  const renderErrorModal = () => {
    return (
      <Dialog open={errModalOpen} onClose={toggleErrModal}>
        <>
          <div style={{ position: 'absolute', right: 5, top: 5, cursor: 'pointer' }}>
            <CloseOutlined onClick={toggleErrModal} />
          </div>
          <div
            style={{
              backgroundColor: 'white',
              padding: 25,
              maxWidth: 'md',
              textAlign: 'center',
              margin: 'auto'
            }}
          >
            <p style={{ fontSize: 20 }}>
              <span dangerouslySetInnerHTML={{ __html: errMsg }} />
            </p>
            <Button
              onClick={toggleErrModal}
              style={{ marginTop: 20, color: 'white', backgroundColor: 'black' }}
              className="hlx-button "
              variant="contained"
            >
              Close
            </Button>
          </div>
        </>
      </Dialog>
    );
  };

  const getMnVtVerbiage = () => {
    if (isLicensed) {
      return VTMNVerbiageLicensed;
    }
    return VTMNVerbiage;
  };

  const updateFormField = (field) => {
    return (event) => {
      if (_.includes(['email_consent', 'communication_optin'], field)) {
        return setFormValues({ ...formValues, [field]: event.target.checked });
      }

      if (
        _.includes(['licensed_state', 'state'], field) &&
        _.includes(['MN', 'VT'], event.target.value)
      ) {
        setErrMsg(getMnVtVerbiage());
        setErrModalOpen(true);
      }

      setFormValues({ ...formValues, [field]: event.target.value });
    };
  };

  const onVirtualHybridChange = (label) => {
    return (e) => {
      if (e.target.checked) {
        // console.log('lavel here', label);
        setAttendanceType(label);
      }
    };
  };

  const updateSelectMultiple = (field) => {
    return (values) => {
      setFormValues({ ...formValues, [field]: values });
    };
  };

  const triggerBlockerModal = (errorMsg) => {
    setErrMsg(errorMsg);
    setErrModalOpen(true);
  };

  const onVtMTChange = (field) => {
    return (e) => {
      if (field === 'is_mn_vm_yes') {
        if (e.target.checked) {
          setisVtMn(true);
          triggerBlockerModal(getMnVtVerbiage());
        }
      } else {
        setisVtMn(false);
      }
    };
  };

  const getVtMtValue = (field) => {
    if (isVtMn === null) {
      return false;
    }
    if (field === 'is_mn_vm_yes') {
      return isVtMn ? true : false;
    } else {
      return isVtMn ? false : true;
    }
  };

  const onStateEmployeeChange = (field) => {
    return (e) => {
      if (field === 'is_state_employee_yes') {
        if (e.target.checked) {
          setIsStateEmployee(true);
          triggerBlockerModal(StateEmployeeVerbiage);
        }
      } else {
        setIsStateEmployee(false);
      }
    };
  };

  const getStateEmployeeValue = (field) => {
    if (isStateEmploee === null) {
      return false;
    }
    if (field === 'is_state_employee_yes') {
      return isStateEmploee ? true : false;
    } else {
      return isStateEmploee ? false : true;
    }
  };
  const onFormularyCommitteeChange = (field) => {
    return (e) => {
      if (field === 'is_formulary_committee_yes') {
        if (e.target.checked) {
          setIsFormularyCommittee(true);
          triggerBlockerModal(FormularyCommiteeVerbiage);
        }
      } else {
        setIsFormularyCommittee(false);
      }
    };
  };

  const getFormularyCommitteeValue = (field) => {
    if (isFormularyCommittee === null) {
      return false;
    }
    if (field === 'is_formulary_committee_yes') {
      return isFormularyCommittee ? true : false;
    } else {
      return isFormularyCommittee ? false : true;
    }
  };

  const renderScreeningFields = () => {
    return (
      <>
        <div
          className="reg-switch-to-mobile"
          style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}
        >
          <InputLabel htmlFor="is_mn_vm_yes" style={{ marginRight: 12, color: 'black' }}>
            *Do you hold a state license in either VT or MN?
          </InputLabel>
          <div>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={getVtMtValue('is_mn_vm_yes')}
                    onChange={onVtMTChange('is_mn_vm_yes')}
                    name="is_mn_vm_yes"
                  />
                }
                label="Yes"
              />
            </FormControl>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={getVtMtValue('is_mn_vm_no')}
                    onChange={onVtMTChange('is_mn_vm_no')}
                    name="is_mn_vm_no"
                  />
                }
                label="No"
              />
            </FormControl>
          </div>
        </div>
        {formErrors.isVtMn && (
          <FormHelperText
            className="center-text-on-mobile"
            style={{ color: '#f44336', marginLeft: 14 }}
          >
            This field is required.
          </FormHelperText>
        )}
        <div
          className="reg-switch-to-mobile"
          style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}
        >
          <InputLabel htmlFor="is_state_employee_yes" style={{ marginRight: 12, color: 'black' }}>
            *Are you employed by the state of Colorado, Connecticut, Kentucky, or Louisiana?
          </InputLabel>
          <div>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={getStateEmployeeValue('is_state_employee_yes')}
                    onChange={onStateEmployeeChange('is_state_employee_yes')}
                    name="is_state_employee_yes"
                  />
                }
                label="Yes"
              />
            </FormControl>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={getStateEmployeeValue('is_state_employee_no')}
                    onChange={onStateEmployeeChange('is_state_employee_no')}
                    name="is_state_employee_no"
                  />
                }
                label="No"
              />
            </FormControl>
          </div>
        </div>
        {formErrors.isStateEmploee && (
          <FormHelperText
            className="center-text-on-mobile"
            style={{ color: '#f44336', marginLeft: 14 }}
          >
            This field is required.
          </FormHelperText>
        )}
        <div
          className="reg-switch-to-mobile"
          style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}
        >
          <InputLabel
            htmlFor="is_formulary_committee_yes"
            style={{ marginRight: 12, color: 'black' }}
          >
            *Do you serve on a formulary committee for the District of Columbia?
          </InputLabel>
          <div>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={getFormularyCommitteeValue('is_formulary_committee_yes')}
                    onChange={onFormularyCommitteeChange('is_formulary_committee_yes')}
                    name="is_formulary_committee_yes"
                  />
                }
                label="Yes"
              />
            </FormControl>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={getFormularyCommitteeValue('is_formulary_committee_no')}
                    onChange={onFormularyCommitteeChange('is_formulary_committee_no')}
                    name="is_formulary_committee_no"
                  />
                }
                label="No"
              />
            </FormControl>
          </div>
        </div>
        {formErrors.isFormularyCommittee && (
          <FormHelperText
            className="center-text-on-mobile"
            style={{ color: '#f44336', marginLeft: 14 }}
          >
            This field is required.
          </FormHelperText>
        )}
      </>
    );
  };

  const renderNpiFields = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <TextField
            disabled={Boolean(npiInfo && /^\d{10}$/.test(npiDataObj.npi))}
            fullWidth
            style={{ margin: 10 }}
            value={formValues.npi || ''}
            onChange={updateFormField('npi')}
            label={'*NPI'}
            error={formErrors.npi}
            helperText={formErrors.npi && 'NPI must be 10 digits'}
            margin={'dense'}
            variant={'outlined'}
            type="number"
          />
        </div>
        {renderScreeningFields()}
        <div style={{ width: '50%', display: 'flex' }} className="mobile-portrait-width-unset">
          <FormControl fullWidth style={{ margin: 10 }}>
            <InputLabel
              htmlFor="licensed_state"
              style={{ color: formErrors.licensed_state && 'red' }}
            >{`${isLicensed && '*'}Licensed State`}</InputLabel>
            <MuiSelect
              native
              variant={'outlined'}
              value={formValues.licensed_state || ''}
              onChange={updateFormField('licensed_state')}
              margin={'dense'}
              label={`${isLicensed && '*'}Licensed State`}
              error={formErrors.licensed_state}
              inputProps={{
                name: 'licensed_state',
                id: 'licensed_state',
                maxLength: 2
              }}
            >
              {/* <option aria-label="None" key="none" value="" /> */}
              {_.map(dropDownValues.states, (state) => {
                return (
                  <option key={state.abrv} value={state.abrv}>
                    {state.name}
                  </option>
                );
              })}
            </MuiSelect>
          </FormControl>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.license_number || ''}
            onChange={updateFormField('license_number')}
            label={'License #'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 30 }}
          />
        </div>
      </div>
    );
  };

  if (submitted) {
    return <h2>Thank you for submitting your registration!</h2>;
  }

  return (
    <div>
      {renderErrorModal()}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.firstname)}
            style={{ margin: 10 }}
            value={formValues.firstname || ''}
            onChange={updateFormField('firstname')}
            label={'*First Name'}
            margin={'dense'}
            variant={'outlined'}
            error={formErrors.firstname}
            inputProps={{ maxLength: 35 }}
          />
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.minitial)}
            style={{ margin: 10 }}
            value={formValues.minitial || ''}
            onChange={updateFormField('minitial')}
            label={'Middle Name Initial'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 1 }}
          />
        </div>
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.lastname)}
            style={{ margin: 10 }}
            value={formValues.lastname || ''}
            onChange={updateFormField('lastname')}
            label={'*Last Name'}
            margin={'dense'}
            variant={'outlined'}
            error={formErrors.lastname}
            inputProps={{ maxLength: 35 }}
          />
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.suffix)}
            style={{ margin: 10 }}
            value={formValues.suffix || ''}
            onChange={updateFormField('suffix')}
            label={'Suffix'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 75 }}
          />
        </div>
        {isLicensed && (
          <>
            <TextField
              style={{ margin: 10 }}
              value={formValues.prodesignation || ''}
              onChange={updateFormField('prodesignation')}
              label={'Professional Designation/Title'}
              margin={'dense'}
              variant={'outlined'}
              error={formErrors.title}
              inputProps={{ maxLength: 50 }}
            />
            <div
              style={{ display: 'flex', marginTop: 10 }}
              className="mobile-column-reverse-switch"
            >
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <FormControl style={{ marginLeft: 10, marginRight: 10, display: 'block' }}>
                  <SelectMultiField
                    values={formValues.specialty}
                    label={'*Specialty'}
                    options={_.map(specialties, (specialty) => ({
                      value: specialty.name,
                      label: specialty.name
                    }))}
                    onChange={updateSelectMultiple('specialty')}
                    error={formErrors.specialty}
                  />
                </FormControl>
                {_.find(
                  formValues.specialty || [],
                  (spclty) => spclty.value.toUpperCase() === 'OTHER'
                ) && (
                  <TextField
                    fullWidth
                    style={{ margin: 10, paddingRight: 20 }}
                    value={formValues.other_specialty || ''}
                    onChange={updateFormField('other_specialty')}
                    label={'*Other Specialty'}
                    error={formErrors.other_specialty}
                    margin={'dense'}
                    variant={'outlined'}
                    inputProps={{ maxLength: 50 }}
                  />
                )}
                <FormHelperText style={{ marginLeft: 15 }}>
                  If you cannot locate your specialty from this drop-down menu, please contact your
                  local sales representative, as you may not be permitted to attend this
                  program.{' '}
                </FormHelperText>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%'
                }}
              >
                <FormControl
                  style={{
                    display: 'block',
                    margin: '2px 10px 5px 10px'
                  }}
                >
                  <SelectMultiField
                    values={formValues.degree}
                    label={'*Degree'}
                    options={_.map(degrees, (degree) => ({
                      value: degree.name,
                      label: degree.name
                    }))}
                    onChange={updateSelectMultiple('degree')}
                    error={formErrors.degree}
                  />
                </FormControl>
                {_.find(
                  formValues.degree || [],
                  (degree) => degree.value.toUpperCase() === 'OTHER'
                ) && (
                  <TextField
                    fullWidth
                    style={{ margin: 10, paddingRight: 20 }}
                    value={formValues.other_degree || ''}
                    onChange={updateFormField('other_degree')}
                    label={'*Other Degree'}
                    error={formErrors.other_degree}
                    margin={'dense'}
                    variant={'outlined'}
                    inputProps={{ maxLength: 50 }}
                  />
                )}
              </div>
            </div>
          </>
        )}
        {!isLicensed && (
          <>
            {' '}
            <div
              style={{ display: formValues.role?.toUpperCase() === 'OTH' && 'flex' }}
              className="mobile-column-switch"
            >
              <div
                style={{
                  padding: 10,
                  width: formValues.role?.toUpperCase() === 'OTH' ? '100%' : '50%'
                }}
                className="mobile-role-width-switch"
              >
                <FormControl fullWidth>
                  <InputLabel error={formErrors.role} htmlFor="role">
                    *Identify the role that best describes you
                  </InputLabel>
                  <MuiSelect
                    native
                    variant={'outlined'}
                    value={formValues.role}
                    onChange={updateFormField('role')}
                    error={formErrors.role}
                    label="*Identify the Role that best describes you"
                    margin={'dense'}
                    inputProps={{
                      name: 'role',
                      id: 'role',
                      maxLength: 50
                    }}
                  >
                    <option aria-label="None" key="none" value="" />
                    {_.map(roles, (role) => {
                      return (
                        <option key={role.subcatid} value={role.subcatcode}>
                          {role.name}
                        </option>
                      );
                    })}
                  </MuiSelect>
                </FormControl>
              </div>
              {formValues.role?.toUpperCase() === 'OTH' && (
                <TextField
                  style={{ margin: 10, minWidth: '50%' }}
                  value={formValues.other_role || ''}
                  onChange={updateFormField('other_role')}
                  label={'*Other Role'}
                  error={formErrors.other_role}
                  margin={'dense'}
                  variant={'outlined'}
                  inputProps={{ maxLength: 100 }}
                />
              )}
            </div>
            {renderScreeningFields()}
          </>
        )}

        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.orgname || ''}
            onChange={updateFormField('orgname')}
            label={'*Affiliation'}
            error={formErrors.orgname}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 100 }}
          />
        </div>

        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.address1 || ''}
            onChange={updateFormField('address1')}
            label={'*Office Address'}
            error={formErrors.address1}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.address2 || ''}
            onChange={updateFormField('address2')}
            label={'Address 2'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
        </div>
        <div className="flex mobile-column-switch">
          <TextField
            style={{ margin: 10, minWidth: '30%' }}
            value={formValues.city || ''}
            onChange={updateFormField('city')}
            label={'*City'}
            error={formErrors.city}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
          <div className="flex" style={{ minWidth: '50%' }}>
            <FormControl style={{ margin: 10, flex: '1 50px' }}>
              <InputLabel error={formErrors.state} htmlFor="state">
                *State
              </InputLabel>
              <MuiSelect
                native
                variant={'outlined'}
                value={formValues.state || ''}
                onChange={updateFormField('state')}
                error={formErrors.state}
                margin={'dense'}
                label="*State"
                inputProps={{
                  name: 'state',
                  id: 'state',
                  maxLength: 2
                }}
              >
                {_.map(dropDownValues.states, (state) => {
                  return (
                    <option key={state.abrv} value={state.abrv}>
                      {state.name}
                    </option>
                  );
                })}
              </MuiSelect>
            </FormControl>
            <TextField
              fullWidth
              style={{ margin: 10, flex: '1 100px' }}
              value={formValues.zip || ''}
              onChange={updateFormField('zip')}
              label={'*Zip'}
              error={formErrors.zip}
              margin={'dense'}
              variant={'outlined'}
              inputProps={{ minLength: 5, maxLength: 10 }}
            />
          </div>
        </div>
        {isLicensed && renderNpiFields()}
        {/* {!isLicensed && renderStateLicenseNumber()} */}
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.phone || ''}
            onChange={updateFormField('phone')}
            label={'Phone'}
            error={formErrors.phone}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 15 }}
            type="tel"
          />
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.fax || ''}
            onChange={updateFormField('fax')}
            label={'Fax'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 15 }}
            type="tel"
          />
        </div>
        <div style={{ display: 'flex' }}>
          {/* <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.home_phone || ''}
            onChange={updateFormField('home_phone')}
            label={'Home Phone'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 15 }}
            type="tel"
          /> */}
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.email || ''}
            onChange={updateFormField('email')}
            label={'*Email'}
            error={formErrors.email}
            helperText={formErrors.email && 'Invalid email address'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 100 }}
            type="email"
          />
        </div>
        <div style={{ padding: 10 }}>
          <TextField
            className="multiLineTextField"
            fullWidth
            multiline
            rows={5}
            value={formValues.dietary_constraints || ''}
            onChange={updateFormField('dietary_constraints')}
            InputLabelProps={{
              style: { fontSize: 14, paddingRight: 5 }
            }}
            label={'Dietary Constraints, optional, not all programs include a meal'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
        </div>
        <div style={{ padding: 10 }}>
          <TextField
            className="multiLineTextField"
            fullWidth
            multiline
            rows={5}
            value={formValues.comments || ''}
            InputLabelProps={{
              style: { fontSize: 14 }
            }}
            onChange={updateFormField('comments')}
            label={'Comments'}
            variant={'outlined'}
            inputProps={{ maxLength: 100 }}
          />
        </div>
        <div style={{ paddingLeft: 10, marginBottom: 20 }}>
          <FormControl required error={formErrors.email_consent}>
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  checked={formValues.email_consent || false}
                  onChange={updateFormField('email_consent')}
                  name="email_consent"
                />
              }
              label="I give my consent to use my email address for communications involving this event"
            />
            {formErrors.email_consent && <FormHelperText>This field is required.</FormHelperText>}
          </FormControl>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  checked={formValues.communication_optin}
                  onChange={updateFormField('communication_optin')}
                  name="communication_optin"
                />
              }
              label="I consent to receive additional non-program communications from Sobi Pharmaceuticals."
            />
            {/* {formErrors.communication_optin && <FormHelperText>This field is required.</FormHelperText>} */}
          </FormControl>
        </div>
        {/* {meetingInfo.sms_opt_in_enabled && (
          <div style={{ paddingLeft: 10, marginBottom: 10 }}>
            <FormControl required error={formErrors.sms_opt_in}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    checked={formValues.sms_opt_in}
                    onChange={updateFormField('sms_opt_in')}
                    name="sms_opt_in"
                  />
                }
                label="Opt in for mobile text messages about this event"
              />
              {formErrors.sms_opt_in && <FormHelperText>This field is required.</FormHelperText>}
            </FormControl>
          </div>
        )} */}
        {meetingInfo.is_virtual_hybrid && (
          <div style={{ paddingLeft: 10, marginBottom: 20 }}>
            <FormControl required error={formErrors.attendanceType}>
              <span style={{ maxWidth: 750 }}>
                The program you are registering for is hybrid and can accomodate both in-person and
                virtual attendees. <br />
                Please confirm how you are planning to attend by choosing from the options below.
              </span>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="default"
                      checked={attendanceType === 'in-person'}
                      onChange={onVirtualHybridChange('in-person')}
                      name="is_virtual_hybrid"
                    />
                  }
                  label="In-person"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="default"
                      checked={attendanceType === 'virtual'}
                      onChange={onVirtualHybridChange('virtual')}
                      name="is_virtual_hybrid"
                    />
                  }
                  label="Virtual"
                />
              </FormGroup>
              {formErrors.attendanceType && (
                <FormHelperText style={{ color: '#f44336' }}>
                  This field is required.
                </FormHelperText>
              )}
            </FormControl>
          </div>
        )}
      </div>
      {submitError && (
        <p style={{ color: 'red', textAlign: 'center', fontSize: 20 }}>{submitError}</p>
      )}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ width: 125 }}
          className="hlx-button"
          variant="contained"
          onClick={submitForm}
        >
          Register
        </Button>
        <Button
          className="cancel-btn hlx-button"
          variant="contained"
          onClick={() => setData({ npiInfo: null, isLicensed: null })}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { dropDownValues, isLicensed, npiInfo, meetingInfo, regSource } = data;
  return { dropDownValues, isLicensed, npiInfo, meetingInfo, regSource };
};
export default connect(mapStateToProps, { setData })(SobiRegFormComponent);
